<script lang="ts">
  import { page } from '$app/stores';
  import { startStoryblokBridge } from '$lib/storyblok';
  import DynamicPage from '$pages/dynamic-page.svelte';
  import { AUTH_DRAWER_IDS } from '$lib/constants';
  import { drawer } from '$lib/stores/drawer';

  export let data;

  if (data.story) {
    startStoryblokBridge(data.story.id, (newStory) => {
      data.story = newStory;
    });
  }

  const isLogin = $page.url.searchParams.get('login') === 'true';

  if (isLogin) {
    setTimeout(() => {
      drawer.open(AUTH_DRAWER_IDS.LOGIN);
    }, 1000);
  }
</script>

{#if data.story}
  {#key data.story.uuid}
    <DynamicPage {data} />
  {/key}
{/if}
